import {NgModule, Component, Pipe, OnInit} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import * as lodash from 'lodash';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthGuardService} from '../../services/auth-guard.service';
import { ViewChild } from '@angular/core';
import { MessageComponent } from '../../components/messages/message.component';
import { UserService } from '../../services/user.service';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './recoverpassword.html',
  styleUrls: ['./recoverpassword.scss']
})
export class RecoverPasswordComponent implements OnInit {
  email: FormControl; 
  recoverForm: FormGroup;
  private redirect: string;
  @ViewChild(MessageComponent) public messageComponent: MessageComponent;


  public constructor(
      private http: HttpClient, private router: Router, private route: ActivatedRoute,
      private user: UserService) {}

  ngOnInit() {
    this.createFormControls();
    this.createForm();
    this.route.queryParams.subscribe(params => {
        this.redirect = params.redirect_to;
      });  
  }

  createFormControls() {
    this.email = new FormControl(
        '', [Validators.required, Validators.pattern("[^ @]*@[^ @]*")]);    
  }

  createForm() {
    this.recoverForm = new FormGroup({email: this.email});
  }

  onSubmit() {   
    if (this.recoverForm.valid) {
      const email = this.email.value.toLowerCase();      
      this.user.recoverPassword(email).subscribe( res => {
        this.messageComponent.showSuccess("Success! Please verify your email to reset your password.");
        let stopCondition = false;
        Observable.interval(2000)
        .takeWhile(() => !stopCondition)
        .subscribe(i => { 
          if (this.redirect) {
            window.location.href = this.redirect;
          }
          stopCondition = true;
        })     
      }, err => {
        if (err && err.error && err.error.errors  && err.error.errors.length > 0) {
          this.messageComponent.showError(err.error.errors[0].message);
        } else {
          this.messageComponent.showError(err);
        }
      });
    }
  }

  

  private isBadCredentials(error) {
    const code = lodash.get(error, 'errors[0].code', 0);
    // 104: Invalid user credentials | 117: Number of login attempts exceeded
    return code === 104 || code === 117;
  }

}


// WEBPACK FOOTER //
// ./src/app/pages/recoverpassword/recoverpassword.ts